import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  keyword: "",
  loading: false,
  sortConfig: {
    key: "createdAt",
    direction: "ASC",
  },
};

export const KonfigurasiDatabase = createSlice({
  name: "konfigurasiDatabase",
  initialState,
  reducers: {
    ChangeData: (state, action) => {
      state.data = action.payload;
    },
    ChangeKeyword: (state, action) => {
      state.keyword = action.payload;
    },
    ChangeLoading: (state, action) => {
      state.loading = action.payload;
    },
    ChangeSortConfig: (state, action) => {
      state.sortConfig = action.payload;
    },
  },
});

export const { ChangeData, ChangeKeyword, ChangeLoading, ChangeSortConfig } =
  KonfigurasiDatabase.actions;

export default KonfigurasiDatabase.reducer;
